import { validatePhoneNumberForLogin } from '@ahm/common-helpers';
import { useTranslations } from 'next-intl';
import { z } from 'zod';
import { type Locales, createTranslations, locales } from '../locales';

export default function useUserPlaceSchema(lang: keyof Locales) {
  const t = createTranslations({ locales, lang });
  const tAuth = useTranslations('system.auth');

  return z.object({
    name: z
      .string({ required_error: t('error_name_alias_required') })
      .min(1, { message: t('error_name_alias_length') }),
    address: z.string({ required_error: t('error_choose_address') }),
    lat: z
      .number({ required_error: t('error_choose_address') })
      .refine((value) => value !== 0, { message: t('error_choose_address') }),
    lng: z
      .number({ required_error: t('error_choose_address') })
      .refine((value) => value !== 0, { message: t('error_choose_address') }),
    address_detail: z.string().optional(),
    contact_name: z.string().optional(),
    contact_number: z
      .string()
      .refine((value) => validatePhoneNumberForLogin(value), {
        message: tAuth('invalidPhoneNumber'),
      })
      .optional()
      .or(z.literal('')),
  });
}
